import { z } from 'zod'
import { zJsonBlob } from '../common'
import { zArticleStatus, zGenerationStage } from '../enums'
import { zQualityCheck, zQualityChecks } from './article'

export const zGenerationStatus = z.object({
  status: zArticleStatus,
  currentStage: zGenerationStage,
  revisionCount: z.number(),
  maxRevisions: z.number(),
  tokenCostCents: z.number().nullable(),
  model: z.string().nullable(),
  generatedAt: z.string().nullable(),
  error: z.string().nullable(),
})
export type GenerationStatus = z.infer<typeof zGenerationStatus>

export const zGenerationEvent = z
  .object({
    stage: z.string(),
    at: z.string().nullable(),
    error: z.string().optional().nullable(),
  })
  .passthrough()
export type GenerationEvent = z.infer<typeof zGenerationEvent>

export const zPreview = z.object({
  frontmatter: zJsonBlob.nullable(),
  bodyMdx: z.string().nullable(),
  qualityChecks: zQualityChecks.nullable(),
  warnings: z.array(z.string()).default([]),
})
export type Preview = z.infer<typeof zPreview>

export const zValidateResult = z.object({
  qualityChecks: zQualityChecks,
  passed: z.boolean(),
  // Each failure is a quality-check row (same shape as qualityChecks entries).
  failures: z.array(zQualityCheck),
})
export type ValidateResult = z.infer<typeof zValidateResult>
